/** @jsxImportSource @emotion/react */

import React, { useState, useEffect } from 'react'
import PageTitle from '../../components/PageTitle'
import Seo from '../../components/Seo'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { toast } from 'react-toastify'
import PageWrapper from '../../components/PageWrapper'
import { USER_CLICKUP_AUTH } from '../../graphql/clickup.graphql'
import { useMutation } from '@apollo/client'
import CircularProgress from '@material-ui/core/CircularProgress'
import ClickupAuthButton from './ClickupAuthButton'
import { fetchClickupClientId } from '../../utils/clickupConfig'

const ClickupAuthPage = () => {
  const [token, setToken] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [userClickupAuth] = useMutation(USER_CLICKUP_AUTH)
  const location = useLocation()
  let params = queryString.parse(location.search)
  const code = params.code

  useEffect(() => {
    if (!code) return
    let cancelled = false
    setIsLoading(true)
    ;(async () => {
      try {
        // clientId optional — server uses CLICKUP_CLIENT_ID from its own env
        const clientId = await fetchClickupClientId()
        const res = await userClickupAuth({
          variables: { code, clientId: clientId || undefined },
        })
        if (cancelled) return
        const data = res?.data?.userClickupAuth
        const newToken = data.token
        if (newToken) {
          toast.success(data.message)
          localStorage.setItem('clickup', JSON.stringify(newToken))
          setToken(newToken)
        }
      } catch (error) {
        if (!cancelled) toast.error(error.toString())
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [code])

  useEffect(() => {
    const getToken = JSON.parse(localStorage.getItem('clickup'))
    if (getToken) setToken(getToken)
  }, [])

  return (
    <>
      <Seo title='🔺ClickUp' />
      <PageTitle>
        <h1>ClickUp</h1>
      </PageTitle>
      <PageWrapper>
        <PageWrapper>
          {isLoading ? (
            <>
              <CircularProgress />
              <p css={sText}>Autoryzacja...</p>
            </>
          ) : (
            <>
              {token && (
                <p css={sText}>
                  ✅ Twoje konto Clickup zostało połączone z CITO
                </p>
              )}
              <ClickupAuthButton reload />
            </>
          )}
        </PageWrapper>
      </PageWrapper>
    </>
  )
}

const sText = {
  margin: '2rem 0',
}

export default ClickupAuthPage
